var React = require('react');

function StoreAlt (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M320 384H128V224H64v256a32 32 0 0 0 32 32h256a32 32 0 0 0 32-32V224h-64zm192-160v272a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V224z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M634.55 142.2c14.1 21.3-1.1 49.8-26.6 49.8H32.05c-25.6 0-40.8-28.5-26.6-49.8l85.3-128A31.87 31.87 0 0 1 117.35 0h405.2a32.18 32.18 0 0 1 26.7 14.2z","className":"fa-primary","key":2})]);
}

StoreAlt.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = StoreAlt;

StoreAlt.default = StoreAlt;
